import { Tick } from '@/core/ticks';
import {
  Address,
  NftxV3Uniswap,
  config,
  createQuery,
  getChainConstant,
  querySubgraph,
} from 'nftx.js';
import { parseEther } from 'viem';

const fetchPoolTicks = async ({
  network,
  poolAddress,
  tickIdxLowerBound,
  tickIdxUpperBound,
}: {
  network: number;
  poolAddress: Address;
  tickIdxLowerBound: number;
  tickIdxUpperBound: number;
}) => {
  const query = createQuery<NftxV3Uniswap.Query>()
    .ticks.first(1000)
    .orderBy('tickIdx')
    .where((w) => [
      w.pool.is(poolAddress),
      w.tickIdx.gte(`${tickIdxLowerBound}`),
      w.tickIdx.lte(`${tickIdxUpperBound}`),
    ])
    .select((s) => [
      s.liquidityGross,
      s.liquidityNet,
      s.tickIdx,
      s.price0,
      s.price1,
    ]);

  const data = await querySubgraph({
    url: getChainConstant(config.subgraph.NFTX_UNISWAP_SUBGRAPH, network),
    query,
  });

  return data.ticks.map(
    ({ liquidityGross, liquidityNet, tickIdx, price0, price1 }): Tick => {
      return {
        index: tickIdx,
        liquidityGross: BigInt(liquidityGross),
        liquidityNet: BigInt(liquidityNet),
        prices: [parseEther(price0), parseEther(price1)],
      };
    }
  );
};

export default fetchPoolTicks;
